var webooker_courses_models = webooker_courses_models || {};

(function (ns) {

    // #region courseRegistrationPayment - ctor

    ns.courseRegistrationPayment = function courseRegistrationPayment(dto /* Webooking.Common.Model.PaymentDTO */) {

        this.paymentID = dto.paymentID;
        this.value = dto.value;
        this.paymentType = dto.paymentType;
        this.paymentDate = dto.paymentDate;
        this.cashReceiptNo = dto.cashReceiptNo;
    };

    // #endregion

    // #region courseRegistrationPayment methods

    ns.courseRegistrationPayment.prototype.toJSON = function () {
        return {
            paymentID: this.paymentID,
            value: this.value,
            paymentType: this.paymentType,
            paymentDate: this.paymentDate,
            cashReceiptNo: this.cashReceiptNo
        }
    }

    // #endregion



})(webooker_courses_models);